import type { FetchResult } from '@apollo/client';
import { useMutation } from '@vue/apollo-composable';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import type {
  LoginMutation,
  LoginMutationVariables,
  LoginSource,
} from '@/graphql/generated/types';

import { apolloClient } from '../apolloClient';
import { LOGIN } from '../graphql/login';
import { usePermissionStore } from './permissionStore';

export const useLoginStore = defineStore('auth', () => {
  const isReadyForQueries = ref(false);

  // 使用 useMutation 來執行變異請求
  const { mutate, loading } = useMutation<
    LoginMutation,
    LoginMutationVariables
  >(LOGIN, {
    fetchPolicy: 'network-only',
  });

  const login = async (
    source: LoginSource,
    email: string,
    password: string,
  ): Promise<FetchResult<LoginMutation> | null> => {
    try {
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('hmacSecret');
      isReadyForQueries.value = false;

      const response = await mutate({ source, email, password });

      // 登入成功後儲存所有 workspace 的 permissions，
      // 待 ChooseHeadquarter 選擇 workspace 後再 resolve 當前 workspace 的 codes
      if (response?.data?.login) {
        usePermissionStore().saveLoginPermissions(response.data.login);
      }

      isReadyForQueries.value = true;
      return response;
    } catch (error) {
      console.error('Error during login mutation:', error);
      return null;
    }
  };

  const logout = async () => {
    try {
      await apolloClient.clearStore();
      usePermissionStore().clearPermissions();
      sessionStorage.clear();
      isReadyForQueries.value = false;
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };
  const switchHeadquarter = async () => {
    await apolloClient.clearStore();
  };
  return { login, logout, switchHeadquarter, isReadyForQueries, loading };
});
